export function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

    return weekNo;
}

export function generateWeekOptions() {
    let options = [{ name: "All weeks", value: "all" }];

    let weekStart = 16;
    let currentWeek = getWeekNumber(new Date());

    for (let i = weekStart; i < currentWeek; i++) {
        options.push({ name: `Week ${i}`, value: i });
    }
    return options;
}